import React from "react"
import styled, { keyframes, css } from "styled-components"
import { responsive } from "../../common/styledHelpers"
import CommonContainer from "../../common/components/Container"
import { CardStyle, HeadingTwo } from "buoy-core"
import { fontSize, fontWeight, colors } from "buoy-theme"
import { CardLabel } from "../../common/components/Label"
// 4851-todo: update responsive helper

const collapse = height => keyframes`
  0% {
    max-height: ${height}px;
    margin-bottom: 20px;
    opacity: 1
  }

  ${100 - (20 / (height + 20)) * 100}% {
    max-height: 0px;
    margin-bottom: 20px;
    opacity: 0.5;
  }

  100% {
    max-height: 0px;
    margin-bottom: 0px;
    opacity: 0.5;
  }
`

const CompletionCard = styled.div`
  ${CardStyle}
  position: relative;
  width: 100%;
  max-width: 664px;
  display: flex;
  flex-direction: column;
  ${responsive("padding", "24px 32px 32px", "24px 16px 32px")};
  ${props => props.padding && `padding: ${props.padding};`}
  ${props =>
    props.margin
      ? css`
          margin: ${props.margin};
        `
      : responsive("margin", "0 0 40px", "0 0 24px")};
  ${props => props.noShadow && `box-shadow: none;`}
  ${props =>
    props.noBorder
      ? css`
          border: none;
        `
      : ""}
  ${props =>
    props.hide &&
    `
    animation: ${collapse(props.height)} 0.5s ease-out forwards;
    overflow: hidden;
  `}
`

const CardSection = styled(CommonContainer)`
  border-top: solid 1px ${colors.neutralLight};
  ${props => props.noBorder && "border: none;"}
  ${props =>
    props.bottomBorder &&
    `border-bottom: solid 1px ${colors.neutralLight(props)};`}
  padding: ${props => props.padding};
  cursor: ${props => (props.readMore ? "pointer" : "default")};
  width: 100%;
`

CardSection.defaultProps = {
  padding: "24px 0 32px",
}

const Heading = styled(HeadingTwo)`
  text-align: left;
  margin: 0 auto 16px 0;
  width: 100%;
  font-weight: ${fontWeight.light};
  ${fontSize("h2")};
`

class CardContainer extends React.Component {
  constructor() {
    super()
    this.state = {
      height: 0,
    }
  }

  componentDidUpdate() {
    if (this.container && this.container.offsetHeight > this.state.height) {
      this.setState({ height: this.container.offsetHeight })
    }
  }

  render() {
    return (
      <CompletionCard
        innerRef={c => (this.container = c)}
        {...this.state}
        {...this.props}
      >
        {this.props.children}
      </CompletionCard>
    )
  }
}

export { CardContainer as default, Heading, CardSection, CardLabel }



// WEBPACK FOOTER //
// ./assets/completion/components/Card.js